module Widgets.Form.TextInput where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import Data.Int (floor, toNumber)
import GraphQL.Shape (QueryField(..))
import Widgets.Form.Class (class FormWidget, fieldAccessProps, formWidgetState, fieldClass, fieldId, setFromJson)
import Widgets.Form.Common (widgetLabelS)


newtype TextInput = TextInput TextInputType
derive newtype instance showTextInput :: Show TextInput
type TextInputType =
    { id :: String
    , label :: String
    , cls :: String
    , placeholder :: Maybe String
    , value :: String
    }

instance textInputFW :: FormWidget TextInput where
    getId (TextInput state) = state.id
    isLeaf _ = true
    asField (TextInput state) = Just $ QScalar state.id
    fieldPaths fc (TextInput state) = [ fieldId fc state.id ]

    toWidget fc (TextInput ti) = formWidgetState <$> D.div
        [ P.key id, P.className $ fieldClass ti ]
        [ widgetLabelS fc ti [ P.className "block w-full" ]
        , D.input
            ( [ P._type "text", P._id id, P.value ti.value
            , P.className "widget-input"
            , P.placeholder $ fromMaybe "" ti.placeholder
            , TextInput <$> ti { value = _ } <$> P.unsafeTargetValue <$> P.onInput
            ] <> fieldAccessProps fc ti.id )
        ]
      where id = fieldId fc ti.id

    getData _ (TextInput state) = J.fromString state.value
    setData _ st@(TextInput state) json | J.isNumber json =
        setFromJson st (\(val :: Number) -> if toNumber (floor val) == val
            then Right $ TextInput $ state { value = show $ floor val }
            else Right $ TextInput $ state { value = show val }
        ) json
    setData _ st@(TextInput state) json =
        setFromJson st (\val -> Right $ TextInput $ state { value = val }) json

newtype TextArea = TextArea TextAreaType
derive newtype instance showTextArea :: Show TextArea
type TextAreaType =
    { id :: String
    , label :: String
    , cls :: String
    , placeholder :: Maybe String
    , value :: String
    }

instance textAreaFW :: FormWidget TextArea where
    getId (TextArea state) = state.id
    isLeaf _ = true
    asField (TextArea state) = Just $ QScalar state.id
    fieldPaths fc (TextArea state) = [ fieldId fc state.id ]

    toWidget fc (TextArea ti) = formWidgetState <$> D.div
        [ P.key id, P.className $ fieldClass ti ]
        [ widgetLabelS fc ti [ P.className "block w-full" ]
        , D.textarea
            ( [ P._id id
            , P.className "widget-input"
            , P.placeholder $ fromMaybe "" ti.placeholder
            , TextArea <$> ti { value = _ } <$> P.unsafeTargetValue <$> P.onInput
            , P.value ti.value
            ] <> fieldAccessProps fc ti.id ) []
        ]
      where id = fieldId fc ti.id

    getData _ (TextArea state) = J.fromString state.value
    setData _ st@(TextArea state) json | J.isNumber json =
        setFromJson st (\(val :: Number) -> if toNumber (floor val) == val
            then Right $ TextArea $ state { value = show $ floor val }
            else Right $ TextArea $ state { value = show val }
        ) json
    setData _ st@(TextArea state) json =
        setFromJson st (\val -> Right $ TextArea $ state { value = val }) json
